import { useState } from 'react';
import { Link, Typography } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import LegalDocumentModal, { type LegalDocumentSlug } from '@/components/legal/legal-document.modal';

const linkSx = {
  verticalAlign: 'baseline',
  font: 'inherit',
  cursor: 'pointer',
} as const;

/**
 * Checkout footer copy with Terms / Privacy links that open in an overlay
 * instead of navigating away from the checkout modal.
 */
export default function CheckoutLegalProceedNotice() {
  const t = useTranslations();
  const [documentSlug, setDocumentSlug] = useState<LegalDocumentSlug | null>(null);

  return (
    <>
      <Typography
        variant="caption"
        color="text.secondary"
        component="p"
        sx={{ mt: 1.5, lineHeight: 1.55, display: 'block' }}
      >
        {t('subscription.organization.planPage.subscriptionCheckoutLegalProceed')}{' '}
        <Link
          component="button"
          type="button"
          color="primary"
          underline="hover"
          variant="inherit"
          onClick={() => setDocumentSlug('terms')}
          sx={linkSx}
        >
          {t('subscription.organization.planPage.subscriptionCheckoutLegalTerms')}
        </Link>{' '}
        {t('subscription.organization.planPage.subscriptionCheckoutLegalJoinTermsPrivacy')}{' '}
        <Link
          component="button"
          type="button"
          color="primary"
          underline="hover"
          variant="inherit"
          onClick={() => setDocumentSlug('privacy')}
          sx={linkSx}
        >
          {t('subscription.organization.planPage.subscriptionCheckoutLegalPrivacy')}
        </Link>
        {t('subscription.organization.planPage.subscriptionCheckoutLegalProceedEnd')}
      </Typography>
      <LegalDocumentModal open={documentSlug != null} slug={documentSlug} onClose={() => setDocumentSlug(null)} />
    </>
  );
}
